var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "page" }, [
    _c(
      "div",
      {
        staticClass: "flex-aligncol-center",
        staticStyle: { "margin-top": "200px" },
      },
      [
        _c("img", {
          staticClass: "topic-icon",
          attrs: { src: require("@/assets/topicIcon.png") },
        }),
        _c(
          "div",
          {
            staticClass: "title-1",
            staticStyle: { "font-size": "22px", padding: "20px 0 30px 0" },
          },
          [_vm._v("\n      " + _vm._s(_vm.queryRecord?.name) + "\n    ")]
        ),
        _c("div", [
          _c("span", { staticClass: "tip" }, [
            _vm._v("共" + _vm._s(_vm.baseInfo?.allNum || 0) + "个测评"),
          ]),
          _c("span", { staticClass: "tip" }, [
            _vm._v("题数：" + _vm._s(_vm.baseInfo?.allTopicNum || 0) + "题"),
          ]),
          _c("span", { staticClass: "tip" }, [
            _vm._v("预计用时：" + _vm._s(_vm.baseInfo?.allTime || 0) + "分钟"),
          ]),
        ]),
        _c("div", { staticClass: "submit-text" }, [_vm._v("已提交")]),
      ]
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }